module.exports = __webpack_public_path__ + "static/img/banner_dispatch.922386d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_dispatch.jpg
// module id = l8sr
// module chunks = 15